import { Component } from '@angular/core';

@Component({
    template: require('./sample.modal.component.html')
})
export class ModalSampleComponent {
showDialog: boolean= true;

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/samples/sample.modal/sample.modal.component.ts